import Lights from './Lights.jsx'
import { Level } from './Level.jsx'
import { Physics } from '@react-three/rapier'
import Player from './Player.jsx'
import useGame from './stores/useGame.jsx'
import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'
import * as THREE from 'three'

export default function Experience()
{
    const blocksCount = useGame((state) => state.blocksCount)
    const blocksSeed = useGame((state) => state.blocksSeed)
    const phase = useGame((state) => state.phase)

    const { scene } = useThree()

    useEffect(() => {
        scene.background = new THREE.Color('#0a1628')
        scene.fog = new THREE.Fog('#0a1628', 15, 60)
    }, [scene])

    // Debug mode - colliderlarni ko'rish uchun true qiling
    const debugMode = false

    return (
        <>
            <Physics debug={debugMode}>
                <Lights />
                <Level count={ blocksCount } seed={ blocksSeed } />
                {/* Menu holatda Player ko'rsatilmasin */}
                { phase !== 'menu' && <Player /> }
            </Physics>
        </>
    )
}
